var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Grid, Divider, FormControlLabel, Checkbox, LinearProgress, TextField as MuiTextField, Typography, Box, } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { offerList as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { useRequest } from '../../../hooks/requestHook';
import SelectField from '../../atoms/SelectField';
import DateTimePickerWithTimeZone from '../../atoms/DateTimePickerWithTimeZone';
import Button from '../../atoms/BaseButton';
import CalculateFixedButton from './CalculateFixedButton';
import { PaymentTermValues } from '../../../constants/offerListValues';
import CreateInvoicesDialog from './CreateInvoicesDialog';
import SelectFoundingCuratorDialog from './SelectFoundingCuratorDialog';
import OfferSummariesForm from './OfferSummariesForm';
import StoryUrlsForm from './StoryUrlsForm';
import useDirectlyUpdatableTextField from '../../../hooks/hoc/useDirectlyUpdatableTextField';
import TextField from '../../atoms/TextFieldNew';
import OfferListExchangeRates from './OfferListExchangeRates';
import { camelize } from '../../../utils/camelize';
import { getOneTimeUpfrontRate, getOneTimeUpfrontRateKey, getOneTimeUpfrontRateLabelKey, getInstallmentPaymentsRate, } from '../../../utils/paymentTimingHandlingRates';
import { useOrderListItem } from '../../../hooks/useListItem';
import MultipleSelectField from '../../atoms/SelectFieldNew';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 24px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n\n  .action-button {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n"], ["\n  padding: 0 24px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n\n  .action-button {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n"])));
var StyledBox = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  padding: 5px 0px;\n"], ["\n  display: flex;\n  padding: 5px 0px;\n"])));
var StyledTypography = styled(Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 5px;\n"], ["\n  margin-top: 5px;\n"])));
var ButtonWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  padding-right: 25px;\n"], ["\n  margin-bottom: 5px;\n  padding-right: 25px;\n"])));
var OfferListForm = function (_a) {
    var _b, _c, _d;
    var offerList = _a.offerList, offers = _a.offers, onChange = _a.onChange;
    var t = useTranslation().t;
    var _e = React.useState(false), openCreateInvoicesDialog = _e[0], setOpenCreateInvoicesDialog = _e[1];
    var _f = React.useState(false), openSelectRoasterDialog = _f[0], setOpenSelectRoasterDialog = _f[1];
    var _g = React.useState(false), loading = _g[0], setLoading = _g[1];
    var notify = useNotify();
    var updateOfferList = useRequest(api.update);
    var updateOfferListStatusRequest = useRequest(api.updateStatus);
    var statusValues = t('params.offerList.statuses', {
        returnObjects: true,
    });
    var paymentTimingItems = useOrderListItem().paymentTimingItems;
    var handleOpenCreateInvoicesDialog = React.useCallback(function () { return setOpenCreateInvoicesDialog(true); }, []);
    var handleCloseCreateInvoicesDialog = React.useCallback(function () { return setOpenCreateInvoicesDialog(false); }, []);
    var handleOfferListChange = React.useCallback(function (nextOfferList) {
        onChange(nextOfferList);
    }, [onChange]);
    var updateOfferListRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateOfferList(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onChange(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, updateOfferList, onChange, notify]);
    var handleSelectFoundingCurator = React.useCallback(function (roaster) {
        var data = { id: offerList.id, offer_list: { roaster_id: roaster.id } };
        updateOfferListRequest(data);
    }, [offerList, updateOfferListRequest]);
    var handleDeleteFoundingCurator = React.useCallback(function () {
        var data = { id: offerList.id, offer_list: { roaster_id: null } };
        updateOfferListRequest(data);
    }, [offerList, updateOfferListRequest]);
    var createDateChangeHandler = function (name) { return function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var date, dateFormat, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 5, , 6]);
                    if (!(value !== null)) return [3 /*break*/, 2];
                    date = value;
                    dateFormat = 'yyyy-MM-dd';
                    return [4 /*yield*/, updateOfferListRequest({
                            id: offerList.id,
                            offer_list: (_a = {}, _a[name] = format(date, dateFormat), _a),
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, updateOfferListRequest({
                        id: offerList.id,
                        offer_list: (_b = {}, _b[name] = null, _b),
                    })];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    notify('error', [e_1.message]);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }; };
    var createDateTimeChangeHandler = function (name) { return function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var date, data;
        var _a;
        return __generator(this, function (_b) {
            if (!value)
                return [2 /*return*/];
            date = value;
            date.setMinutes(0);
            date.setSeconds(0);
            data = {
                id: offerList.id,
                offer_list: (_a = {}, _a[name] = date.toJSON(), _a),
            };
            updateOfferListRequest(data);
            return [2 /*return*/];
        });
    }); }; };
    var updateOfferListStatus = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateOfferListStatusRequest({
                        id: offerList.id,
                        offer_list: values,
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    onChange(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [offerList, updateOfferListStatusRequest, onChange, t, notify]);
    var handleChangeStatus = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = event.target.value;
                    return [4 /*yield*/, updateOfferListStatus({ status: value })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [updateOfferListStatus]);
    var handleSelectChange = React.useCallback(function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        var data = { id: offerList.id, offer_list: (_a = {}, _a[name] = value, _a) };
        updateOfferListRequest(data);
    }, [offerList, updateOfferListRequest]);
    var handleChangeOrderable = React.useCallback(function (_, orderable) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateOfferListStatus({ orderable: orderable })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [updateOfferListStatus]);
    var onValueUpdateHandler = React.useCallback(function (value, fieldName) {
        var _a;
        var data = { id: offerList.id, offer_list: (_a = {}, _a[fieldName] = value, _a) };
        updateOfferListRequest(data);
    }, [offerList, updateOfferListRequest]);
    var handleUpdateTypicaHandlingRates = React.useCallback(function (value, field) {
        var _a;
        var nextTypicaHandlingRates = __assign(__assign({}, offerList.typicaHandlingRates), (_a = {}, _a[field] = value, _a));
        onValueUpdateHandler(nextTypicaHandlingRates, 'typica_handling_rates');
    }, [onValueUpdateHandler, offerList.typicaHandlingRates]);
    var handleUpdateAvailablePaymentTimings = React.useCallback(function (value) {
        onValueUpdateHandler(value, 'available_payment_timings');
    }, [onValueUpdateHandler]);
    var updatePaymentTimingHandlingRates = React.useCallback(function (value, field) {
        var _a;
        var nextValue = __assign(__assign({}, offerList.paymentTimingHandlingRates), (_a = {}, _a[field] = value, _a));
        onValueUpdateHandler(nextValue, 'payment_timing_handling_rates');
    }, [onValueUpdateHandler, offerList.paymentTimingHandlingRates]);
    var statusItems = React.useMemo(function () {
        return Object.entries(statusValues).map(function (_a) {
            var value = _a[0], text = _a[1];
            return ({
                value: value,
                text: text,
            });
        });
    }, [statusValues]);
    var producerFieldsDisabled = React.useMemo(function () { return offerList.status !== 'draft'; }, [offerList.status]);
    var maxSampleOrderCountItems = React.useMemo(function () {
        var maxSampleOrderCountList = [1];
        if (offers.length > 0) {
            maxSampleOrderCountList = __spreadArray([], Array(offers.length), true).map(function (_v, i) { return i + 1; });
        }
        return maxSampleOrderCountList.map(function (num) { return ({
            text: "".concat(num),
            value: "".concat(num),
        }); });
    }, [offers.length]);
    var paymentTermItems = React.useMemo(function () {
        return PaymentTermValues.map(function (term) { return ({
            value: term,
            text: t("params.offerList.paymentTerms.".concat(term)),
        }); });
    }, [t]);
    var DirectUpdateTextField = useDirectlyUpdatableTextField(TextField);
    if (!offerList)
        return React.createElement(LinearProgress, null);
    return (React.createElement(Form, null,
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(DirectUpdateTextField, { fullWidth: true, margin: "normal", label: t('params.offerList.name'), name: "name", value: offerList.name, onUpdate: onValueUpdateHandler }))),
        React.createElement(Divider, null),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(SelectField, { fullWidth: true, label: t('params.offerList.status'), margin: "normal", name: "status", value: offerList.status, onChange: handleChangeStatus, items: statusItems })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3, className: "checkbox-field" },
                React.createElement(FormControlLabel, { name: "orderable", control: React.createElement(Checkbox, { color: "primary" }), label: t('params.offerList.orderable'), labelPlacement: "end", checked: offerList.orderable, onChange: handleChangeOrderable })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(SelectField, { fullWidth: true, select: true, margin: "normal", label: t('params.offerList.maxSampleOrderCount'), name: "max_sample_order_count", value: offerList.maxSampleOrderCount, onChange: handleSelectChange, items: maxSampleOrderCountItems })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(SelectField, { fullWidth: true, select: true, margin: "normal", label: t('params.offerList.paymentTerm'), name: "payment_term", value: offerList.paymentTerm, onChange: handleSelectChange, items: paymentTermItems, disabled: producerFieldsDisabled })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DatePicker, { label: t('params.offerList.sampleDeliveryDate'), inputFormat: "yyyy-MM-dd", value: offerList.sampleDeliveryDate
                        ? new Date(offerList.sampleDeliveryDate)
                        : null, onChange: createDateChangeHandler('sample_delivery_date'), InputAdornmentProps: {
                        'aria-label': 'change date',
                    }, renderInput: function (inputProps) { return (React.createElement(MuiTextField, __assign({}, inputProps, { margin: "normal", variant: "outlined" }))); }, disabled: producerFieldsDisabled })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DateTimePickerWithTimeZone, { label: t('params.offerList.orderStartedAt'), value: offerList.orderStartedAt
                        ? new Date(offerList.orderStartedAt)
                        : null, onChange: createDateTimeChangeHandler('order_started_at') })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DateTimePickerWithTimeZone, { label: t('params.offerList.expiredAt'), value: offerList.expiredAt ? new Date(offerList.expiredAt) : null, onChange: createDateTimeChangeHandler('expired_at') })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { fullWidth: true, type: "number", margin: "normal", label: t('params.offerList.publishDays'), name: "publish_days", value: offerList.publishDays, onUpdate: onValueUpdateHandler, disabled: producerFieldsDisabled })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                React.createElement(StyledBox, null,
                    React.createElement(ButtonWrapper, null,
                        React.createElement(Button, { onClick: function () { return setOpenSelectRoasterDialog(true); }, disabled: loading || ((_b = offerList.salesContract) === null || _b === void 0 ? void 0 : _b.status) === 'published' }, offerList.roaster
                            ? t('buttons.changeFoundingCurator')
                            : t('buttons.selectFoundingCurator'))),
                    offerList.roaster && (React.createElement(React.Fragment, null,
                        React.createElement(ButtonWrapper, null,
                            React.createElement(Button, { onClick: handleDeleteFoundingCurator, disabled: Boolean(offerList.salesRewardRate) ||
                                    loading ||
                                    ((_c = offerList.salesContract) === null || _c === void 0 ? void 0 : _c.status) === 'published' }, t('buttons.deleteFoundingCurator'))),
                        React.createElement(StyledTypography, { variant: "h3" }, "".concat(t('params.offerList.roaster'), ": ").concat(t('fullname', offerList.roaster))))))),
            offerList.roaster && (React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                    React.createElement(DirectUpdateTextField, { fullWidth: true, type: "number", margin: "normal", label: "".concat(t('params.offerList.salesRewardRate'), "(%)"), name: "sales_reward_rate", value: offerList.salesRewardRate || '', disabled: ((_d = offerList.salesContract) === null || _d === void 0 ? void 0 : _d.status) === 'published', inputProps: { step: 0.1, min: 0, max: 30 }, onUpdate: onValueUpdateHandler, transformValue: function (value) {
                            if (parseInt(value) < 0) {
                                return '0';
                            }
                            if (parseInt(value) > 30) {
                                return '30';
                            }
                            return value;
                        } })),
                React.createElement(Grid, { item: true, xs: 12, sm: 9 })))),
        React.createElement(Divider, null),
        React.createElement(OfferListExchangeRates, { offerList: offerList }),
        React.createElement(Divider, null),
        React.createElement(StoryUrlsForm, { storyUrls: offerList.storyUrls, onUpdate: onValueUpdateHandler }),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(DirectUpdateTextField, { fullWidth: true, margin: "normal", label: t('params.offerList.infoMaterialUrl'), name: "info_material_url", value: offerList.infoMaterialUrl, onUpdate: onValueUpdateHandler }))),
        React.createElement(Divider, null),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "subtitle1" }, t('params.offerList.typicaHandlingRates'))),
            Object.entries(offerList.typicaHandlingRates).map(function (_a) {
                var key = _a[0], value = _a[1];
                return (React.createElement(Grid, { key: key, item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", disabled: !['draft'].includes(offerList.status), label: t("params.offerList.typicaHandlingRate.".concat(camelize(key))), name: key, value: value, onUpdate: handleUpdateTypicaHandlingRates })));
            })),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "subtitle1" }, t('params.offerList.paymentTimingHandlingRates'))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t(getOneTimeUpfrontRateLabelKey(offerList.paymentTimingHandlingRates)), name: getOneTimeUpfrontRateKey(offerList.paymentTimingHandlingRates), disabled: !['draft'].includes(offerList.status), value: getOneTimeUpfrontRate(offerList.paymentTimingHandlingRates, false), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.oneTimeSpecifiedDateRate'), name: "one_time_specified_date_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'one_time_specified_date_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.oneTimeAfterImportedRate'), name: "one_time_after_imported_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'one_time_after_imported_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.lumpSumPaymentAfterImportRate'), name: "lump_sum_payment_after_import_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'lump_sum_payment_after_import_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.twoTimesAfterImportedRate'), name: "two_times_after_imported_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'two_times_after_imported_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.threeTimesAfterImportedRate'), name: "three_times_after_imported_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'three_times_after_imported_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.fourTimesAfterImportedRate'), name: "four_times_after_imported_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'four_times_after_imported_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.fiveTimesAfterImportedRate'), name: "five_times_after_imported_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'five_times_after_imported_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.oneTimeAfterFirstDeliveryRate'), name: "one_time_after_first_delivery_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'one_time_after_first_delivery_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DirectUpdateTextField, { type: "number", margin: "normal", label: t('params.offerList.paymentTimingHandlingRate.afterEachDeliveryRate'), name: "after_each_delivery_rate", disabled: !['draft'].includes(offerList.status), value: getInstallmentPaymentsRate(false, 'after_each_delivery_rate', offerList.paymentTimingHandlingRates), onUpdate: updatePaymentTimingHandlingRates })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 })),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "subtitle1" }, t('params.offerList.availablePaymentTimings'))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(MultipleSelectField, { items: paymentTimingItems, value: offerList.availablePaymentTimings, multiple: true, variant: "standard", disabled: !['draft'].includes(offerList.status), onChange: handleUpdateAvailablePaymentTimings }))),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DatePicker, { label: t('params.offerList.paymentDueDate'), inputFormat: "yyyy-MM-dd", value: offerList.paymentDueDate
                        ? new Date(offerList.paymentDueDate)
                        : null, onChange: createDateChangeHandler('payment_due_date'), InputAdornmentProps: {
                        'aria-label': 'change date',
                    }, renderInput: function (inputProps) { return (React.createElement(MuiTextField, __assign({}, inputProps, { margin: "normal", variant: "outlined" }))); }, disabled: producerFieldsDisabled }))),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(DatePicker, { label: t('params.offerList.estimatedPaymentDate'), inputFormat: "yyyy-MM-dd", value: offerList.estimatedPaymentDate
                        ? new Date(offerList.estimatedPaymentDate)
                        : null, onChange: createDateChangeHandler('estimated_payment_date'), InputAdornmentProps: {
                        'aria-label': 'change date',
                    }, renderInput: function (inputProps) { return (React.createElement(MuiTextField, __assign({}, inputProps, { margin: "normal", variant: "outlined" }))); }, disabled: producerFieldsDisabled }))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(DirectUpdateTextField, { fullWidth: true, multiline: true, rows: 3, margin: "normal", label: t('params.offerList.comment'), name: "comment", value: offerList.comment, onUpdate: onValueUpdateHandler })),
        React.createElement(OfferSummariesForm, { offerSummaries: offerList.offerSummaries, onUpdate: onValueUpdateHandler }),
        React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, sm: 6, className: "action-button" },
                React.createElement(CalculateFixedButton, { id: offerList.id, fixed: offerList.fixed, onChange: onChange })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6, className: "action-button" }, offerList.fixed && (React.createElement(Button, { onClick: handleOpenCreateInvoicesDialog }, t('pages.offerList.createInvoices'))))),
        React.createElement(CreateInvoicesDialog, { offerList: offerList, open: openCreateInvoicesDialog, onClose: handleCloseCreateInvoicesDialog, onOfferListChange: handleOfferListChange }),
        React.createElement(SelectFoundingCuratorDialog, { open: openSelectRoasterDialog, onClose: function () { return setOpenSelectRoasterDialog(false); }, onSubmit: handleSelectFoundingCurator, loading: loading })));
};
export default OfferListForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
